import { constants as pageConstants } from "rivals/components/pages/User/Subscriptions/Cancellation/strings";

export const constants = {
  ...pageConstants,
  CANCELLATION_INITIATED: "Cancellation Initiated"
} as const;

export default {
  editSubscriptionText: "Edit Subscription",
  navigateToAllSubscriptions: "Back to Subscriptions",
  nextBillingDate: (nextBillingDate: string): string =>
    `next billing date: ${nextBillingDate}`,
  renewingTitle: (nextBillingDate: string): string =>
    `Renews on ${nextBillingDate}`,
  subTotalText: (subtotal: string): string => `Sub total: ${subtotal}`,
  taxText: (tax: string | null): string => (tax ? `Tax: ${tax}` : ""),
  totalText: (total: string): string => `Total: ${total}`,
  upgradeDefaultText: "Upgrade"
};
